import { render, staticRenderFns } from "./AttachmentEditor.vue?vue&type=template&id=0ec16ea8&scoped=true&"
import script from "./AttachmentEditor.vue?vue&type=script&lang=js&"
export * from "./AttachmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentEditor.vue?vue&type=style&index=0&id=0ec16ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec16ea8",
  null
  
)

export default component.exports